export default API => ({
    // // 课时资源-列表
    findByConditionWithPage(url,data) {
        return API({ url: `/resource/v1/resource/findResourceApplicationByReqWithPage?${url}`, method:  'post',  data})
    },
    // // 查视频完整url
    previewMedia(videoId) {
        return API({ url: `/resource/v1/resource/getVideoPlayURL?videoId=${videoId}`})
    },
    // 文档，图片url
    getImageOrDocUrl(id) {
        return API({ url: `/resource/v1/resource/getImageOrDocUrl?id=${id}`})
    },
    // 素材   申请使用
    batchApply(data){
        return API({url: `/resource/v1/resApplication/batchApply`,method:'post',data})
    },
})
